import { render, staticRenderFns } from "./NothingToShow.vue?vue&type=template&id=65a3a069&"
import script from "./NothingToShow.vue?vue&type=script&lang=js&"
export * from "./NothingToShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports